<div class="wrapper" [dir]="direction">
  <app-loading></app-loading>
  <router-outlet />
  <!-- <app-cookies-banner></app-cookies-banner> -->
</div>
